import { IDENTITY_ROLES } from '@ayocore/platform/identity/common/roles';
import { AuthController } from '@ayocore/platform/identity/client/AuthController';

/**
 * Guard-предикат для пунктов меню: доступно только администратору.
 *
 * Используется в `useNavigation()` как `guard: isAdmin` — единый источник истины
 * для всех системных/административных разделов, чтобы каждый модуль не копировал
 * проверку роли себе в bootstrap.
 *
 * Возвращает `false`, если пользователь не загружен или роли ADMIN у него нет
 * (fail-secure: при сомнении пункт скрыт).
 *
 * @example
 * ```ts
 * core.useNavigation([
 *   { icon: IconActivity, label: 'Системный монитор', url: '/core/monitor', guard: isAdmin },
 * ]);
 * ```
 *
 * > Важно: guard управляет только видимостью в меню. Роут по прямой ссылке
 * > остаётся доступен — доступ к данным ограничивает серверный RBAC.
 */
export const isAdmin = (): boolean => {
  const user = AuthController.getInstance().getSnapshot().user;
  return user?.roles?.includes(IDENTITY_ROLES.ADMIN) ?? false;
};
